import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useRouteError } from 'react-router';
import { getRootUrl } from '../utils/utils';
import { captureEvent } from '../utils/analytics';
import Content from '../components/layout/Content';
import { notifyMonitoring } from '../utils/monitoring';
import { NOT_FOUND } from '../constants/errors';

const PAGE_NOT_FOUND = 'Oops, looks like this page does not exist';
const SOMETHING_WRONG = 'Oops, something went wrong!';

const ErrorBoundaryContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 48px;
`;

const ImgContainer = styled.div`
  height: 30vh;
  border-radius: 16px;
`;

export const DefaultErrorView = ({ message = SOMETHING_WRONG }) => (
  <Content>
    <ErrorBoundaryContainer className="overflow-auto">
      <h1>{message}</h1>
      <p>
        This may be a bad URL. Try going back to <a href={getRootUrl()}>home</a>{' '}
        and trying again. If the problem persists, start a chat with us using
        the blue chat icon or{' '}
        <a href="mailto:support@propagateag.com">send us an email!</a>
      </p>
      <ImgContainer className="mb-2">
        <img
          src="/images/ErrorMessage.png"
          alt="An anthropomorphic chestnut holding a sign that says 'Sorry'"
        />
      </ImgContainer>
      {process.env.NODE_ENV === 'development' && (
        <div>
          <h2>Hey, developer!</h2>
          <p>The application encountered an error. Find it in the console.</p>
        </div>
      )}
    </ErrorBoundaryContainer>
  </Content>
);

export const NotFoundView = () => <DefaultErrorView message={PAGE_NOT_FOUND} />;

const ErrorBoundaryView = () => {
  const error = useRouteError();
  const notFound = error.message === NOT_FOUND;

  useEffect(() => {
    captureEvent('error-boundary-hit');
  }, []);

  if (!notFound) notifyMonitoring(error);

  return notFound ? <NotFoundView /> : <DefaultErrorView />;
};

export default ErrorBoundaryView;
